<mat-toolbar class="imc--cap">
  <mat-toolbar-row>
    <img class="logoGeneralitat" width="7em" [src]="idiomaActual == 'es' ? 'assets/images/gv_conselleria_innova_bn_cast.png' : 'assets/images/gv_conselleria_innova_bn_val.png'" alt="" />

    <span class="remaining-space"></span>

    <mat-button-toggle-group aria-label="Font Style" class="imc--idioma" #idioma="matButtonToggleGroup" (change)="changeLanguage(idioma.value)" multiple="false" [(ngModel)]="idiomaActual" *ngIf="isAuthenticated()">
      <mat-button-toggle value="ca" [value]="'ca'" [ayudaPantalla]="'header.lang.tooltip.ca' | translate">
        <span>{{ 'header.lang.ca' | translate }}</span>
      </mat-button-toggle>
      <mat-button-toggle value="es" [value]="'es'" [ayudaPantalla]="'header.lang.tooltip.es' | translate">
        <span>{{ 'header.lang.es' | translate }}</span>
      </mat-button-toggle>
    </mat-button-toggle-group>
  </mat-toolbar-row>

  <mat-toolbar-row fxLayout="row" fxLayoutAlign="start center">
    <div *ngIf="isAuthenticated() || isIdentified()" class="imc--usuari">
      <mat-card-header *ngIf="!isIdentified()">
        <mat-icon mat-card-avatar *ngIf="isAuthenticated()">person</mat-icon>
        <mat-card-title> {{ 'AUTH.USER' | translate }} {{ 'AUTH.TIPO.ANONIMO' | translate }} </mat-card-title>
      </mat-card-header>
      <mat-card-header *ngIf="isIdentified()" routerLink="/ficha-usuario" [ayudaPantalla]="'header.menu.nombreUsuario.ayudaPantalla' | translate" style="cursor: pointer">
        <mat-icon mat-card-avatar *ngIf="isAuthenticated()">person</mat-icon>
        <mat-card-title> {{ account.firstSurname }}, {{ account.firstName }} </mat-card-title>
        <mat-card-subtitle *ngIf="account.authType == 'GENERICO'"> ({{ account.login }}) {{ 'AUTH.USER' | translate }} {{ 'AUTH.TIPO.GENERICO' | translate }} </mat-card-subtitle>
        <mat-card-subtitle *ngIf="account.authType == 'IDESP'"> ({{ account.docId }}) {{ 'AUTH.USER' | translate }} {{ 'AUTH.TIPO.VERIFICADO' | translate }} </mat-card-subtitle>
        <mat-card-subtitle *ngIf="account.authType == 'CLAVE'"> ({{ account.docId }}) {{ 'AUTH.USER' | translate }} {{ 'AUTH.TIPO.CLAVE' | translate }} </mat-card-subtitle>
      </mat-card-header>
    </div>
    <div fxFlex="20" *ngIf="!isAuthenticated() && !isIdentified()"></div>

    <div fxFlex="60">
      <!-- NOSOLIC -->
      <!-- <button mat-button *ngIf="isIdentified()" routerLink="/solicitantes" [ayudaPantalla]="'header.menu.solicitantesVinculados.ayudaPantalla' | translate">
        <mat-icon>group</mat-icon>
        <span>{{ 'header.menu.solicitantesVinculados.etiqueta' | translate }}</span>
      </button> -->

      <button mat-button *ngIf="isAuthenticated()" routerLink="/convocatorias" [ayudaPantalla]="'header.menu.convocatorias.ayudaPantalla' | translate">
        <mat-icon>folder</mat-icon>
        <span>{{ 'header.menu.convocatorias.etiqueta' | translate }}</span>
      </button>

      <button mat-button *ngIf="isIdentified()" routerLink="/notificaciones" [ayudaPantalla]="'header.menu.notificaciones.ayudaPantalla' | translate">
        <mat-icon class="imc--notificacions" matBadge="{{ numNotificacionesPorLeer }}" *ngIf="numNotificacionesPorLeer !== 0">notifications</mat-icon>
        <mat-icon class="imc--notificacions" *ngIf="numNotificacionesPorLeer === 0">notifications</mat-icon>
        <span class="imc--notificacions">{{ 'header.menu.notificaciones.etiqueta' | translate }}</span>
      </button>
    </div>

    <div fxFlex *ngIf="isAuthenticated()">
      <button mat-button telAyudaPantalla [matMenuTriggerFor]="ayudaMenu" [ayudaPantalla]="'header.menu.ayuda.ayudaPantalla' | translate">
        <mat-icon>help</mat-icon>
        <span>{{ 'header.menu.ayuda.etiqueta' | translate }}</span>
      </button>

      <mat-menu #ayudaMenu="matMenu">
        <button mat-menu-item (click)="abrirAyudaDocumento()">
          <mat-icon style="color: #912d3c">picture_as_pdf</mat-icon>
          <span>{{ 'header.menu.ayuda.manual' | translate }}</span>
        </button>
      </mat-menu>

      <button mat-button (click)="abrirPersonalizar()" [ayudaPantalla]="'header.menu.personalizar.ayudaPantalla' | translate">
        <mat-icon>settings</mat-icon>
        <span>{{ 'header.menu.personalizar.etiqueta' | translate }}</span>
      </button>

      <button mat-button (click)="logout()" [ayudaPantalla]="'header.menu.salir.ayudaPantalla' | translate">
        <mat-icon>exit_to_app</mat-icon>
        <span>{{ 'header.menu.salir.etiqueta' | translate }}</span>
      </button>
    </div>
  </mat-toolbar-row>
</mat-toolbar>
